import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';

export const GET_FILTERS_REQUEST = 'GET_FILTERS_REQUEST';
export const GET_FILTERS_SUCCESS = 'GET_FILTERS_SUCCESS';
export const GET_FILTERS_ERROR = 'GET_FILTERS_ERROR';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';

export function getFiltersRequestAction(options) {
	return { type: GET_FILTERS_REQUEST, options };
}

export function getFiltersSuccessAction(data) {
	return { type: GET_FILTERS_SUCCESS, data };
}

export function getFiltersErrorAction(error) {
	return { type: GET_FILTERS_ERROR, error };
}

export function clearFiltersAction() {
	return { type: CLEAR_FILTERS };
}

export function fetchFiltersAction(options, requestHeaders = {}) {
	return dispatch => {
		dispatch(getFiltersRequestAction(options));
		const searchOptions = {
			store: options.sid || 'search.flipkart.com',
			filters: 'facet-show=all',
			ssid: 'random',
			sqid: 'random'
		};

		options.qtag && (searchOptions.q = encodeURIComponent(options.qtag));
		options.q && (searchOptions.q = encodeURIComponent(options.q));
		options.filter && (searchOptions.facets = encodeURIComponent(`${searchOptions.facets},${options.filter}`));
		options['p[]'] &&
			Array.isArray(options['p[]']) &&
			(searchOptions.filters = ['facet-show=all', ...options['p[]']].map(x => encodeURIComponent(x)));
		options.tagName && (searchOptions.tag = `tags[]=${options.tagName}`);
		options.tagKey && options.tagValue && (searchOptions.view = `${options.tagKey}%3D${options.tagValue}`);
		options.sort && (searchOptions.sort = options.sort);
		options.author && (searchOptions.view = `contributor%3D${options.author}`);
		options.author && (searchOptions.store = 'bks');
		options.pincode && (searchOptions.pincode = options.pincode);
		options.offer && (searchOptions.santaOffers = options.offer);

		options.ssid && (searchOptions.ssid = options.ssid);
		options.sqid && (searchOptions.sqid = options.sqid);

		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				headers: Object.assign({}, headers, requestHeaders),
				pathname: '/api/1/product/smart-browse/facets',
				action: GET_FILTERS_REQUEST,
				query: searchOptions
			})
		).then(
			json => dispatch(getFiltersSuccessAction(json['RESPONSE'])),
			err => {
				dispatch(getFiltersErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}
